import { Gender } from '@/@types/user'

export function getThirdPersonPronoun(gender?: Gender) {
	switch (gender) {
		case Gender.MALE:
			return '他'
		case Gender.FEMALE:
			return '她'
		default:
			return 'TA'
	}
}
